import { Link } from "react-router-dom";
import { ShieldHalf, DatabaseBackup, Cpu, Activity, ArrowUpRight } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";

const PILLARS = [
  { icon: ShieldHalf, title: "Cyber Risk Assessment", desc: "Identify exposure across accounts, devices, email, and vendors." },
  { icon: DatabaseBackup, title: "Data & Records Security", desc: "Protect the documents that prove your case and run your business." },
  { icon: Cpu, title: "AI Implementation", desc: "Practical, secure AI workflows that save time without new risk." },
  { icon: Activity, title: "Operational Continuity", desc: "Plans that keep the business running through disruption." },
];

export const OperationsReview = () => (
  <section id="operations-review" className="relative py-20 sm:py-24 md:py-32 btr-bg-graphite overflow-hidden" data-testid="operations-review-section">
    <div className="absolute inset-0 btr-grid-animated opacity-25 pointer-events-none" />
    <div className="btr-beam btr-beam-drift" style={{ width: 520, height: 520, bottom: "-20%", right: "-10%", background: "#a2020b", opacity: 0.18 }} />
    <div className="relative max-w-7xl mx-auto px-6">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <SectionHead
          badge="Business Operations Review"
          title={<>Cybersecurity &amp; <span className="text-[#a2020b]">AI</span> — the risks you can&rsquo;t see.</>}
          lede="Modern loss is not only physical. We review how your business protects data, systems, and operations — and help you adopt AI safely."
        />
        <Link to="/topics/business-operations" className="btr-reveal btr-btn-primary self-start lg:self-auto flex-shrink-0" data-testid="operations-review-cta">
          Explore Operations Review <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
        {PILLARS.map((p, i) => {
          const Icon = p.icon;
          return (
            <div key={p.title} className="btr-reveal btr-glass rounded-lg p-6 hover:border-[#a2020b]/45 transition-colors" style={{ transitionDelay: `${i * 60}ms` }} data-testid={`ops-pillar-${i}`}>
              <div className="w-11 h-11 rounded-md bg-[#a2020b]/12 border border-[#a2020b]/35 flex items-center justify-center btr-red-glow">
                <Icon className="w-5 h-5 text-[#a2020b]" strokeWidth={1.5} />
              </div>
              <div className="font-display font-bold text-white text-base mt-5">{p.title}</div>
              <div className="font-body text-zinc-400 text-sm mt-2 leading-relaxed">{p.desc}</div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
